export function HeadlineLarge({children, color, fontWeight = 500}) {
    return (
        <span style={{
            lineHeight: '1.05em',
            fontFamily: 'Open Sans',
            fontSize: '2em',
            display: 'block',
            color,
            fontWeight,
        }}>{children}</span>
    );
}
